export default __webpack_public_path__ + "d5909c788e1a8ea8568dd29ec03889f6.png";